export const comments_5618940 = {"data":{"data":[],"links":{}}}